import {IAttributes, INgModelController, IRootElementService, IScope} from "angular";
import {NumberUtil} from "../../../../js/util/NumberUtil";
import {PriceStrategy} from "./PriceStrategy";
import {Optional} from "../../../../js/util/Optional";

export const PriceStep = "priceStep";

/** @ngInject */
export function priceStep() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function link($scope: IScope, $elem: IRootElementService, $attr: IAttributes, ngModel: INgModelController) {

            const UP_KEY_CODE = 38;
            const DOWN_KEY_CODE = 40;

            let strategy: PriceStrategy = $scope.$eval($attr.priceStep);

            const obs = $attr.$observe("priceStep", (v: string) => {
                strategy = $scope.$eval(v);
                validate(ngModel.$modelValue);
            });

            const bindingWatch = $scope.$watch(() => $scope.$eval($attr.priceStep), (value: PriceStrategy) => {
                strategy = value;
            });

            $elem.on("keydown", (event: JQueryEventObject) => {
                const key = event.keyCode;
                if (key === UP_KEY_CODE) {
                    event.preventDefault();
                    tickUp();
                } else if (key === DOWN_KEY_CODE) {
                    event.preventDefault();
                    tickDown();
                }
            });

            const validityKey = "price-step";

            const validate = (value: number | null) => {
                if (value == null || strategy == null) {
                    ngModel.$setValidity(validityKey, true);
                } else {
                    const step = strategy.stepSize(value);
                    const isValid = NumberUtil.isPowerOf(value, step);
                    ngModel.$setValidity(validityKey, isValid);
                }
            };

            const validateWatch = $scope.$watch(() => ngModel.$modelValue, validate);

            const tickUp = () => {
                let value = ngModel.$modelValue || 0;
                value = Optional.of(strategy)
                                .map(strat => strat.tickUp(value))
                                .orElseGet(() => Number(value) + 1);
                const viewVal = Optional.of(strategy)
                                        .map(strat => strat.format(value, false))
                                        .orElseGet(() => String(value));
                ngModel.$setViewValue(viewVal);
                ngModel.$commitViewValue();
                ngModel.$render();
            };

            const tickDown = () => {
                let value = ngModel.$modelValue || 0;
                value = Optional.of(strategy)
                                .map(strat => strat.tickDown(value))
                                .orElseGet(() => Number(value) - 1);
                const viewVal = Optional.of(strategy)
                                        .map(strat => strat.format(value, false))
                                        .orElseGet(() => String(value));
                ngModel.$setViewValue(viewVal);
                ngModel.$commitViewValue();
                ngModel.$render();
            };

            $scope.$on("$destroy", () => {
                obs();
                validateWatch();
                bindingWatch();
                ngModel.$setValidity(validityKey, true);
            });
        }
    };
}
